module.exports = __webpack_public_path__ + "static/media/Spending.7064ed0b.svg";